import React from 'react';
import {t} from 'i18next';
import {SmallText, FlexColumnSection} from "../styles/globalStyles";

const CourseAgeRestrictionDisplay = ({course, series, ...rest}) => {

    const hasAgeRestriction = (entity) => entity?.min_age != null;

    const getCourseAgeRestrictionDisplay = (entity) => {
        if (!hasAgeRestriction(entity)) {
            return null;
        }
        const minAge = entity.min_age;
        const maxAge = entity.max_age;
        const label = t('course-age-restriction-label');

        if (maxAge != null) {
            return {
                label,
                detail: t('course-age-between-summary', {minAge, maxAge}),
            };
        }
        return {
            label,
            detail: t('course-age-from-summary', {minAge}),
        };
    };

    const display = getCourseAgeRestrictionDisplay(series ?? course);

    if (!display) {
        return null;
    }

    return (
        <FlexColumnSection {...rest}>
            <SmallText weight={'bold'}>{display.label}:</SmallText>
            {display.detail}
        </FlexColumnSection>
    );
};

export default CourseAgeRestrictionDisplay;
